import { useRouter } from "next/router";
import { CustomerItem, CustomerListFilter } from "../../types/customer";
import CustomerActiveMemberships from "./CustomerActiveMemberships";
import DevicePhoneMobileIcon from "../../icons/devicePhoneMobile.icon";
import EnvelopeIcon from "../../icons/envelope.icon";
import { UseFormReturn, useWatch } from "react-hook-form";

interface CustomerListItemProps {
  customer: CustomerItem;
  methods: UseFormReturn<CustomerListFilter, any>;
}

export default function CustomerListItem({ customer, methods }: CustomerListItemProps) {
  const router = useRouter();
  const search = useWatch({ control: methods.control, name: "search" });

  function handleRoute(id: string) {
    let url = `/customers?id=${id}`;
    if (search) url += `&search=${search}`;
    if (router.query.page) url += `&page=${router.query.page}`;

    router.push(url);
  }

  const customerId = router.query.id;

  return (
    <div
      data-email={customer.email}
      className={`border-b-[1px] pb-4 flex justify-between items-start gap-2 ${
        customerId === customer.id ? "text-her-americanYellow" : ""
      }`}
      onClick={() => handleRoute(customer.id)}
    >
      <div className="min-w-0 flex-1">
        <p className="font-bold text-lg">
          {customer.lastName} {customer.firstName}
        </p>
        <CustomerActiveMemberships
          membership={customer.membership}
          className="mt-1 text-xs text-her-green font-medium truncate"
        />
      </div>
      <div className="text-sm flex flex-col items-end">
        {customer.email && (
          <div className="flex gap-1 items-center">
            <EnvelopeIcon className="w-4 h-4 text-her-green" /> {customer.email}
          </div>
        )}
        {customer.mobileNumber && (
          <div className="flex gap-1 items-center font-mono">
            <DevicePhoneMobileIcon className="w-4 h-4 text-her-green" /> {customer.mobileNumber}
          </div>
        )}
      </div>
    </div>
  );
}
